(function () {
  var popover, overlay, activeBtn;

  function parseAndReplace() {
    var walker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );

    var pattern = /\[\[(\d+)\s*\|\s*([^|]+)\|\s*([^|]+)\|\s*([^|]+)\|\s*([^\]]+)\]\]/g;
    var nodesToReplace = [];

    var node;
    while ((node = walker.nextNode())) {
      if (node.parentNode && node.parentNode.id === 'taio-citations-data') continue;
      if (pattern.test(node.nodeValue)) {
        nodesToReplace.push(node);
      }
      pattern.lastIndex = 0;
    }

    nodesToReplace.forEach(function (textNode) {
      var val = textNode.nodeValue;
      var container = document.createElement('span');
      container.innerHTML = val.replace(pattern, function (_, num, title, meta, summary, url) {
        var t = title.trim();
        var m = meta.trim();
        var s = summary.trim();
        var u = url.trim();
        return '<button class="taio-cite" type="button" '
          + 'data-title="' + escAttr(t) + '" '
          + 'data-meta="' + escAttr(m) + '" '
          + 'data-summary="' + escAttr(s) + '" '
          + 'data-url="' + escAttr(u) + '" '
          + 'aria-label="Przypis ' + escAttr(num) + ': ' + escAttr(t) + '">'
          + num
          + '</button>';
      });

      textNode.parentNode.replaceChild(container, textNode);
    });

    document.querySelectorAll('.taio-cite').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        openPopover(this);
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openPopover(this);
        }
      });
    });
  }

  function openPopover(btn) {
    activeBtn = btn;
    popover.querySelector('.tcp__title').textContent = btn.dataset.title;
    popover.querySelector('.tcp__meta').textContent = btn.dataset.meta;
    popover.querySelector('.tcp__summary').textContent = btn.dataset.summary;
    popover.querySelector('.tcp__link').href = btn.dataset.url;

    popover.setAttribute('aria-hidden', 'false');
    popover.classList.add('tcp--visible');
    overlay.classList.add('tcp--visible');

    if (window.innerWidth >= 750) {
      positionPopover(btn);
    }

    popover.querySelector('.tcp__close').focus();
  }

  function positionPopover(btn) {
    var rect = btn.getBoundingClientRect();
    var pw = 320;
    var ph = popover.offsetHeight || 220;
    var gap = 10;
    var vw = window.innerWidth;
    var vh = window.innerHeight;

    var left = rect.left + rect.width / 2 - pw / 2;
    var top = rect.bottom + gap;

    if (left + pw > vw - gap) left = vw - pw - gap;
    if (left < gap) left = gap;
    if (top + ph > vh - gap) top = rect.top - ph - gap;
    if (top < gap) top = gap;

    popover.style.left = left + 'px';
    popover.style.top = top + 'px';
  }

  function closePopover() {
    popover.classList.remove('tcp--visible');
    overlay.classList.remove('tcp--visible');
    popover.setAttribute('aria-hidden', 'true');
    if (activeBtn) {
      activeBtn.focus();
      activeBtn = null;
    }
  }

  function escAttr(str) {
    return str.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function init() {
    popover = document.getElementById('taio-citation-popover');
    overlay = document.getElementById('taio-citation-overlay');
    if (!popover || !overlay) return;

    parseAndReplace();

    popover.querySelector('.tcp__close').addEventListener('click', closePopover);
    overlay.addEventListener('click', closePopover);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePopover();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();